export default {
    ALL: 'ALL',
    ISSUES: 'ISSUES',
    SURRENDERED: 'SURRENDERED',
    OPEN: 'OPEN',
    DATE_RANGE: 'DATE_RANGE'
};
